<template>
  <span class="icon-wrapper" @click="switchVisability">
    <UiBaseIcon :icon-name="icon" width="16px" height="16px" color="#989898" />
  </span>
</template>

<script>
import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'

export default {
  components: { UiBaseIcon },
  data() {
    return {
      passwordVisible: false,
    }
  },
  computed: {
    icon() {
      return this.passwordVisible ? 'eye' : 'eyeClose'
    },
  },
  methods: {
    switchVisability() {
      if (!this.$parent.$refs.input) return

      this.passwordVisible = !this.passwordVisible

      this.$parent.$refs.input.type = this.passwordVisible ? 'text' : 'password'
    },
  },
}
</script>

<style lang="scss" scoped>
.icon-wrapper {
  width: 100%;
  height: 100%;

  @include createFlex(flexbox, nowrap, row, center, center, center);
}
</style>
